import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { Trans } from '@lingui/macro';
import * as React from 'react';
import { MeasuredTitleContainer } from '../components';

const legalProtectionTitle = (
  <Trans>
    Protections légales
  </Trans>
);

const legalProtectionIntro = (
  <Trans>
    Goldwasser Exchange est une Société de Bourse agréée par la Banque Nationale de Belgique et par l'Autorité des Services et Marchés Financiers (FSMA).
  </Trans>
);

export const LegalProtectionSection = (props: {
  widthLines?: ouiStyle.InStyleWithMediaQueries['widthLines'],
  index: number,
  titleBarHeight: number,
  setTitleBarHeight: any,
}) => {
  const {
    titleBarHeight,
    setTitleBarHeight,
    widthLines,
    index,
  } = props;
  return (
    <ouiDom.HeadingSection.HeadingSection
      index={index}
      name="LegalProtection"
      widthLines={widthLines}
      paddingHorizontal="simple"
      paddingTop="simple"
      paddingBottom={['none', undefined, undefined, 'simple', undefined, undefined]}
    >
      <TopModel
        name="HeadingSectionTitleContainer-3"
        color={ouiStyle.Constants.Colors.accent}
        height={titleBarHeight}
        setHeight={setTitleBarHeight}
      >
        {MeasuredTitleContainer}
      </TopModel>
      <TopModel
        name="HeadingSectionIntroContainer"
        color={ouiStyle.Constants.Colors.primary}
      >
        {ouiDom.P.DomPContainer}
      </TopModel>
      <TopModel name="HeadingSectionTitleContent-LegalProtection">
        {legalProtectionTitle}
      </TopModel>
      <TopModel name="HeadingSectionIntroContent-LegalProtection">
        {legalProtectionIntro}
      </TopModel>
    </ouiDom.HeadingSection.HeadingSection>
  );
};
